// actions
export const ACTION_FETCH_AGENT_TITLES = 'ACTION_FETCH_AGENT_TITLES';

// mutations
export const MUTATIONS_SET_AGENT_TITLES = 'MUTATIONS_SET_AGENT_TITLES';

// getters
export const GETTER_AGENT_TITLES = 'GETTER_AGENT_TITLES';
